export default __webpack_public_path__ + "static/media/joys550_wiring.33ace728.jpg";